// src/components/organisms/LoginForm/index.tsx
import { Button } from 'antd';
import { Form, Formik } from 'formik';
import Cookies from 'js-cookie';
import React, { Dispatch, SetStateAction, useState } from 'react';
import { COOKIE_KEYS, COOKIE_OPTIONS } from 'config/cookieConstants';
import authStore from 'stores/auth/AuthStore';
import CheckboxComponent from 'components/atoms/CheckboxComponent';
import InputComponent from 'components/atoms/InputComponet';
import InputPassword from 'components/atoms/InputPassword';
import validationSchema from './validationSchema';
import type { LoginFormModel } from 'models/auth/forms/LoginFormModel';
import { AppRoutes } from 'routes/AppRoutes';
import { useNavigate } from 'react-router-dom';


interface LoginContainerProps {
    setStep: Dispatch<SetStateAction<number>>;
    setRecoverStep: Dispatch<SetStateAction<number>>;
    loading: boolean;
}

const LoginContainer: React.FC<LoginContainerProps> = ({ setStep, setRecoverStep, loading }) => {
    const navigate = useNavigate();
    const [remeberCheckbox, setRemeberCheckbox] = useState(() => {
        const rememberValue = Cookies.get(COOKIE_KEYS.REMEMBER);
        // Retorna true se o cookie for 'true', caso contrário, retorna false
        return rememberValue === 'true';
    });

    const initialValues = {
        email: '',
        password: ''
    };

    // const handleSubmit = async (values: LoginFormModel) => {
    //     const response = await authStore.request2FA(values);

    //     if (!response) {
    //         setStep(2);
    //     }
    // };

    const handleSubmitNo2FA = async (values: LoginFormModel) => {
        const result = await authStore.no2faLogin(values);

        if (result) navigate(AppRoutes.DASHBOARD);
    };

    const remeberLogin = () => {
        const newValue = !remeberCheckbox;
        if (newValue) {
            Cookies.set(COOKIE_KEYS.REMEMBER, 'true', COOKIE_OPTIONS.USER_PREFERENCES);
        } else {
            Cookies.set(COOKIE_KEYS.REMEMBER, 'false', COOKIE_OPTIONS.NOT_REMEMBER)
        }
        setRemeberCheckbox(newValue);
    };


    return (
        <div className="flex flex-col items-center justify-center rounded-xl p-8 bg-white w-full lg:min-w-96 lg:w-min" >
            <div className="flex flex-col items-center justify-center pb-6">
                <p className="font-semibold text-lg">Bem vindo de volta!</p>
                <p className="text-slate-400 text-sm">Faça login para acessar a plataforma</p>
            </div>

            <div className="w-full">
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmitNo2FA}
                >
                    {() => (
                        <Form className="flex flex-col justify-start gap-6 w-full">
                            <InputComponent label="E-mail" name="email" id="email" />
                            <InputPassword label="Senha" name="password" id="password" />

                            <div className="flex justify-between">
                                <CheckboxComponent checked={remeberCheckbox} onChange={remeberLogin} label="Lembrar-se" />
                                <p
                                    className="text-slate-500 text-sm cursor-pointer underline"
                                    onClick={() => setRecoverStep(1)}
                                >
                                    Esqueceu a senha ?
                                </p>
                            </div>

                            <div className="pt-4 w-full">
                                <Button
                                    className="w-full"
                                    htmlType="submit"
                                    type="primary"
                                    loading={loading}
                                >
                                    Entrar
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default LoginContainer;